<template>
  <f7-list-item :title="name" class="total-list-product">
    <div class="detail flex flex-row">
      <div class="left">
        <div class="py-1 mt-1 text-sm">
          單價 ${{ price }}
        </div>
      </div>
      <div class="right">
        <div v-if="quantity - (this.status === 'Completed' ? supplyQuantity.completed_supply_quantity : supplyQuantity.uncompleted_supply_quantity) !== 0" class="warnAmount">
          <span v-if="this.status === 'Completed'">
            {{ supplyQuantity.completed_supply_quantity }}
          </span>
          <span v-else>
            {{ supplyQuantity.uncompleted_supply_quantity }}
          </span>
        </div>
        <div v-else>
          <div class="normalAmount">
            {{ quantity }}
          </div>
        </div>
      </div>
    </div>
  </f7-list-item>
</template>

<script>
export default {
  props: {
    quantity: Number,
    price: String,
    name: String,
    supplyQuantity: Object,
    missingProduct: Array
  },
  data() {
    return {
      status: this.$f7route.query.status,
    }
  },
}
</script>

<style>
.total-list-product .detail .left {
  flex: 3 1 0px;
}

.total-list-product .detail .right {
  flex: 7 1 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
}

.total-list-product .detail .right .warnAmount {
  width: 7rem;
  padding: .25rem 0;
  border-radius: .25rem;
  font-weight: 700;
  text-align: center;
  color: #fff;
  background-color: rgb(239,68,68);
}
.total-list-product .detail .right .normalAmount {
  width: 7rem;
  padding: .25rem 0;
  border-radius: .25rem;
  font-weight: 700;
  text-align: center;
  color: #fff;
  background-color: rgb(0, 0, 0);
}
</style>
